export enum OrderStatus {
  PENDING = 'PENDING',
  READY = 'READY',
  STARTED = 'STARTED',
  FINISHED = 'FINISHED',
  CANCELLED = 'CANCELLED'
}
